import React, { useState, useEffect } from "react"; 
import axios from './utils/axiosConfig';
import {
  BrowserRouter as Router, 
  Route,   
  Routes,   
  useLocation,    
} from "react-router-dom";    
import FilesPage from "./pages/FilesPage"; 
import CreateFilePage from "./pages/CreateFilePage";
import TaskPage from "./pages/TaskPage"; // Import TaskPage
import CreateTaskPage from "./pages/CreateTaskPage"; // Import CreateTaskPage
import ViewEditTaskPage from "./pages/ViewEditTaskPage"; 
import RelationshipPage from "./pages/RelationshipPage"; 
import Login from "./components/auth/Login"; 
import ForgotPassword from "./components/auth/ForgotPassword";
import ResetPassword from "./components/auth/ResetPassword";
import Signup from "./components/auth/Signup";
import CreateRelationshipPage from "./pages/CreateRelationshipPage"; // Import CreateRelationshipPage
import ViewEditRelationshipPage from "./pages/ViewEditRelationshipPage"; // Import ViewEditRelationshipPage
import Sidebar from "./components/Sidebar";
import NavBar from "./components/NavBar";
import HomePage from "./pages/HomePage";
import SpeedDialMenu from "./components/SpeedDialMenu";
import PrivateRoute from "./components/routing/PrivateRoute";
import setAuthToken from "./redux/utils/setAuthToken";
import { useDispatch, useSelector } from "react-redux";
import { loadUser } from "./redux/actions/authActions";
import { initializeLanguageFromStorage } from "./redux/slices/languageSlice";
import RedirectToDashboardOrLogin from "./components/routing/RedirectToDashboardOrLogin"; // Import the new component
import { SnackbarProvider } from "notistack";
import CasesPage from "./pages/CasesPage";
import CalenderPage from "./pages/CalenderPage";
import FinancePage from "./pages/FinancePage";
import TimesheetsPage from "./pages/TimesheetsPage"; // Import TimesheetsPage
import DisbursementsPage from "./pages/DisbursementPage";
import CreateDisbursementPage from "./pages/CreateDisbursementPage"; // Import CreateDisbursementPage
 
import EmailPage from "./pages/EmailPage"; // Import EmailPage



import CreateTimesheetPage from "./pages/CreateTimesheetPage"; // Import CreateTimesheetPage
import EditTimesheetPage from "./pages/EditTimesheetPage"; // Import EditTimesheetPage
import CreateInvoicePage from "./pages/CreateInvoicePage";
import viewEditInvoicePage from "./pages/viewEditInvoicePage";
import ViewEditCreditPage from "./pages/ViewEditCreditPage";
import ViewEditProvisionPage from "./pages/ViewEditProvisionPage";
import CreateCreditPage from "./pages/CreateCreditPage";
import EditFilePage from "./pages/EditFilePage";
import CreateProvisionPage from "./pages/CreateProvisionPage";
import OutlookIntegration from "./pages/OutlookIntegration";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import SendEmail from "./components/SendEmail";
import AlarmSettingsForm from "./components/AlarmSettingsForm";
import SalesDocumentStats from "./components/SalesDocumentStats";
import UserManagement from "./pages/UserManagement";
import DocumentList from "./pages/DocumentList";
import DocumentUpload from "./components/DocumentUpload";
import UploadDocumentFromTemplate from "./pages/UploadDocumentFromTemplate";
import CreateAppointmentPage from "./pages/CreateAppointmentPage";
import CreateHearingPage from "./pages/CreateHearingPage";
import ViewEditAppointmentPage from "./pages/ViewEditAppointmentPage";
import ReportGenerator from "./pages/ReportGenerator";
import ProfilePage from "./pages/ProfilePage";
import ActivityLoggingPage from "./pages/ActivityLoggingPage";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import bulkTimesheetPage from "./pages/bulkTimesheetPage";
import SearchResultsPage from "./pages/SearchResultsPage";
import SettingsPage from "./pages/SettingsPage";
import WorkflowsPage from "./pages/WorkflowsPage";
import CreateWorkflowPage from "./pages/CreateWorkflowPage";
import EditWorkflowPage from "./pages/EditWorkflowPage";
import WorkflowExecutionHistoryPage from "./pages/WorkflowExecutionHistoryPage";
import { WorkflowPromptProvider } from "./contexts/WorkflowPromptContext";
import WorkflowPromptDialog from "./components/WorkflowPromptDialog";

if (localStorage.token) {
  setAuthToken(localStorage.token);
}

// Add this before the App component
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.code === "ERR_NETWORK" || error.message.includes('CORS')) {
      console.log('CORS or network error detected, reloading page...');
      window.location.reload();
      return new Promise(() => { });
    }
    return Promise.reject(error);
  }
);

const App = () => {

  const dispatch = useDispatch();
  const { loading, isAuthenticated } = useSelector((state) => state.userLoaded);
  const location = useLocation();

  useEffect(() => {
    dispatch(loadUser());
    dispatch(initializeLanguageFromStorage());
  }, [dispatch]);

  useEffect(() => {
    document.querySelector("body").style.backgroundColor = "#ECECEC";
  }, []);

  const [sidebarOpen, setSidebarOpen] = useState(true);

  // if (loading) {
  //   return <div>Loading...</div>; // Show a loading spinner or some other loading indicator
  // }

  return (
    <div style={{ display: "flex", backgroundColor: "#ECECEC", }}>
      {isAuthenticated && (
        <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />
      )}
      <div style={{ flex: 1, position: "relative", }}>
        {isAuthenticated && (
          <div
            style={{
              // marginLeft: sidebarOpen ? "200px" : "60px",
              transition: "margin-left 0.3s ease",
            }}
          >
            <NavBar sidebarOpen={sidebarOpen} />
          </div>
        )}
        {isAuthenticated && (
          <SpeedDialMenu />
        )}
        {isAuthenticated && (
          <WorkflowPromptDialog />
        )}
        <main
          style={{ paddingTop: "90px", transition: "margin-left 0.3s ease", }}
        >
          <Routes>
            <Route path="/" element={<RedirectToDashboardOrLogin />} />
            <Route path="/files/:id/:tab" element={<CasesPage />} />
            <Route path="/files/:id/timesheets/options" element={<AlarmSettingsForm />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />

            <Route
              path="/profile"
              element={<PrivateRoute element={ProfilePage} />}
            />
            <Route
              path="/report-generator"
              element={<PrivateRoute element={ReportGenerator} />}
            />
            <Route
              path="/appointment/create"
              element={<PrivateRoute element={CreateAppointmentPage} />}
            />
            <Route
              path="/hearing/create"
              element={<PrivateRoute element={CreateHearingPage} />}
            />
            <Route
              path="/appointment/:id"
              element={<PrivateRoute element={ViewEditAppointmentPage} />}
            />
            <Route
              path="/hearing/:id"
              element={<PrivateRoute element={ViewEditAppointmentPage} />}
            />

            <Route
              path="/user-management"
              element={
                <PrivateRoute element={UserManagement} roles={["Manager"]} />
              }
            />
            <Route
              path="/activity-logging"
              element={
                <PrivateRoute element={ActivityLoggingPage} roles={["Manager"]} />
              }
            />
            <Route
              path="/settings"
              element={
                <PrivateRoute element={SettingsPage} roles={["Manager"]} />
              }
            />
            <Route path="/login" element={<Login />} />
            <Route
              path="/newsignup"
              element={<PrivateRoute element={Signup} roles={["Manager"]} />}
            />
            <Route
              path="/dashboard"
              element={<PrivateRoute element={HomePage} />}
            />
            <Route
              path="/files"
              element={<PrivateRoute element={FilesPage} />}
            />
            <Route
              path="/tasks"
              element={<PrivateRoute element={TaskPage} />}
            />
            <Route
              path="/files/create"
              element={<PrivateRoute element={CreateFilePage} />}
            />
            <Route
              path="/files/edit/:id"
              element={<PrivateRoute element={EditFilePage} />}
            />
            <Route
              path="/tasks/create"
              element={<PrivateRoute element={CreateTaskPage} />}
            />
            <Route
              path="/task/create"
              element={<PrivateRoute element={CreateTaskPage} />}
            />
            <Route
              path="/task/:id"
              element={<PrivateRoute element={ViewEditTaskPage} />}
            />
            <Route
              path="/relationships"
              element={<PrivateRoute element={RelationshipPage} />}
            />
            <Route
              path="/relationships/create"
              element={<PrivateRoute element={CreateRelationshipPage} />}
            />
            <Route
              path="/relationships/:id"
              element={<PrivateRoute element={ViewEditRelationshipPage} />}
            />
            <Route
              path="/timesheets"
              element={<PrivateRoute sidebarOpen={sidebarOpen} element={TimesheetsPage} />}
            />
            <Route
              path="/timesheets/create"
              element={<PrivateRoute element={CreateTimesheetPage} />}
            />
            <Route
              path="/timesheets/bulk/create"
              element={<PrivateRoute element={bulkTimesheetPage} />}
            />
            <Route
              path="/disbursements"
              element={<PrivateRoute sidebarOpen={sidebarOpen} element={DisbursementsPage} />}
            />
            <Route
              path="/disbursements/create"
              element={<PrivateRoute sidebarOpen={sidebarOpen} element={CreateDisbursementPage} />}
            />

            <Route path="/disbursements/edit/:id" element={<CreateDisbursementPage />} /> {/* Edit route */}


            <Route
              path="/finance/create-invoice"
              element={<PrivateRoute element={CreateInvoicePage} />}
            />
            <Route
              path="/invoice/:id"
              element={<PrivateRoute element={viewEditInvoicePage} />} // Change the component
            />
            <Route
              path="/credit/:id"
              element={<PrivateRoute element={ViewEditCreditPage} />} // Change the component
            />
            <Route
              path="/provision/:id"
              element={<PrivateRoute element={ViewEditProvisionPage} />} // Change the component
            />
            <Route
              path="/finance/create-credit"
              element={<PrivateRoute element={CreateCreditPage} />}
            />
            <Route
              path="/finance/create-provision"
              element={<PrivateRoute element={CreateProvisionPage} />}
            />
            <Route
              path="/timesheets/:id"
              element={<PrivateRoute element={EditTimesheetPage} />}
            />
            <Route
              path="/finance"
              element={<PrivateRoute element={FinancePage} />}
            />
            <Route
              path="/emails"
              element={<PrivateRoute element={EmailPage} />}
            />
            <Route
              path="/send-email"
              element={<PrivateRoute element={SendEmail} />}
            />
            <Route
              path="/sales-documents/stats"
              element={<SalesDocumentStats />}
            />

            <Route path="/documents/upload" element={<DocumentUpload />} />
            <Route
              path="/documents/upload-from-template"
              element={<PrivateRoute element={UploadDocumentFromTemplate} />}
            />

            <Route path="/documents" element={<DocumentList />} />

            {/* // <Route path="/cases" element={<CasesPage />} /> */}
            <Route path="/files/:id" element={<CasesPage />} />
            <Route path="/calendar" element={<CalenderPage />} />
            <Route path="/search-results" element={<SearchResultsPage />} />
            <Route path="/workflows" element={<PrivateRoute element={WorkflowsPage} />} />
            <Route path="/workflows/create" element={<PrivateRoute element={CreateWorkflowPage} />} />
            <Route path="/workflows/edit/:id" element={<PrivateRoute element={EditWorkflowPage} />} />
            <Route path="/workflows/:workflowId/executions" element={<PrivateRoute element={WorkflowExecutionHistoryPage} />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

const AppWrapper = () => (
  <Router>
    <SnackbarProvider maxSnack={3}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <ThemeProvider theme={theme}>
          <WorkflowPromptProvider>
            <App />
          </WorkflowPromptProvider>
        </ThemeProvider>
      </LocalizationProvider>
    </SnackbarProvider>
  </Router>
);

export default AppWrapper;
